import BaseView from './_BaseView.js';

export default class LoginView extends BaseView {
    setEvents() {
        super.setEvents();

        $('[name="username"]').focus();

        // Reset password
        $('#login .reset-form input[name="password"]').pwstrength();
        $('#reset-form input[name="password"]').pwstrength();

        // reload the login page every 10 minutes so the token is valid
        if ($('#login-form').length > 0) {
            setTimeout(function () {
                window.location.reload();
            }, 600000);
        }
    }
}
